/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddressValidationRequestPost } from '../../models/address-validation-request-post';
import { AddressValidationResponseGetRecordsList } from '../../models/address-validation-response-get-records-list';

export interface LocationsControllerValidateAddress$Params {
      body: AddressValidationRequestPost
}

export function locationsControllerValidateAddress(http: HttpClient, rootUrl: string, params: LocationsControllerValidateAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<AddressValidationResponseGetRecordsList>> {
  const rb = new RequestBuilder(rootUrl, locationsControllerValidateAddress.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddressValidationResponseGetRecordsList>;
    })
  );
}

locationsControllerValidateAddress.PATH = '/planning-projects/v1-preview/locations/addresses';
